// extracted by mini-css-extract-plugin
module.exports = {"uniqueRef":"UniqueCheck_uniqueRef__1z4PN","tooltip":"UniqueCheck_tooltip___0ICW"};